<template>
  <div style="text-align: center; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
        
      <div style="dispaly: flex; flex-direction: row;">
            <el-radio v-model="search_type" :label="0">
                Customers
            </el-radio>
            <el-radio v-model="search_type" :label="1">
                Stock
            </el-radio>
      </div>  
      <div style="dispaly: flex; flex-direction: row; margin-top: 20px;">
        <el-autocomplete
            style="text-align: left; width: 90%; margin-top: 0px;"
            v-model="search_text"
            id="inventory_item_id"
            :fetch-suggestions="searchSKUCode"
            :placeholder="search_type === 1 ? 'Search by SKU#' : 'Search by customer'"
            :trigger-on-focus="true"
            @select="loadSearchedItem"
        ></el-autocomplete>
        <a @click="openQRScanner" style="cursor: pointer;"><img src="https://etacdn.b-cdn.net/qr-scan.png" width="5%" style="top: 0px; position: relative;"/></a>
      </div>
      
        <br><br>
      <div style="display: flex; flex-direction: column; width: 100%; text-align: left;">
            <el-link 
                v-if="$store.state.inventoryMaster.stock_list.length>0" 
                style="width: 100px; margin-bottom: 20px;" @click="openInventoryWindow">
                <b>View Product</b>
            </el-link>
            <div 
                v-for="(data, index) in $store.state.inventoryMaster.stock_list" 
                :key="index" 
                style="margin: 2px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">
                <el-link @click="showStatement(data.store_id)">
                    {{data.store_name}}
                </el-link>
                <span>
                    {{data.stock}}
                </span>
                    
            </div>
        </div>
        <el-dialog
            v-if="show_qr_window"
            width="70%"
            :visible.sync="show_qr_window"
            append-to-body>
            <qrcode-stream @decode="onDecode" @closed="show_qr_window = false"></qrcode-stream>
        </el-dialog>
        <el-dialog
            v-if="show_statement"
            fullscreen
            :visible.sync="show_statement"
            append-to-body>
            <InventoryStatement @closed="show_statement=false"/>
        </el-dialog>
        <el-dialog
                :title="'Add/Edit Inventory Article'"
                fullscreen
                :visible.sync="showInventoryMaster"
                :close-on-press-escape="false"
                append-to-body
                :show-close="false">
                    <InventoryMaster 
                        :popup="true"
                        @closed="showInventoryMaster = false"/>
            </el-dialog>
  </div>
</template>

<script>
import InventoryStatement from '../InventoryMaster/Form/Statement.vue'
import InventoryMaster from '../InventoryMaster/Form/Index.vue'

export default {
    components: {InventoryStatement, InventoryMaster},
    data() {
        return {
            search_text: '',
            show_qr_window: false,
            show_statement: false,
            store_id: 0,
            item_id: 0,
            search_type: 1,
            showInventoryMaster: false
        }
    },
    computed: {
        getStoreId() {
            return this.store_id
        },
        getItemId() {
            return this.item_id
        },
        getSalesPrice() {
            if(this.$store.getters.getInventoryMasterAutocompleteList.length>0) {

                
                
            }
            return 0
        }
    },
    methods: {
        openInventoryWindow() {
            if(this.checkIfModuleAccessAvailable('/inventoryproducts', 'can_edit')) {
                this.$store.commit('resetInventoryMasterData')
                this.showInventoryMaster = true
                this.$store.dispatch('fetchInventoryMasterData', { id: this.getItemId, copy: false, navigate: false })
            }
        },
        async searchSKUCode(query, cb) {

            if(this.search_type === 1) {
                await this.$store.dispatch('fetchInventoryMasterAutocompleteList', 
                    {query: query, show_all_item: true, search_column: ['sku_code'], store_id: this.$store.getters.getAccessibleStoreList[0].id})

                setTimeout(() => {
                    let list = []
                    this.$store.getters.getInventoryMasterAutocompleteList.forEach(element => {

                        let salePrice = ''
                        if(element.fabric_price_category_id>0 && this.$store.getters.getFabricPriceSlabList.filter(t => t.id == element.fabric_price_category_id).length>0) {
                            salePrice = this.$store.getters.getFabricPriceSlabList.filter(t => t.id == element.fabric_price_category_id)[0].price_category_name
                        } else {
                            salePrice = this.formatCurrency(element.sale_price)
                        }

                        element.value = element.sku_code+', '+element.article_name+', '+salePrice           
                        list.push(element)
                    })
                    cb(list)  
                }, 2000);
            } else if(this.search_type === 0) {

                await this.$store.dispatch('fetchCustomerMasterAutocompleteList', {query: query, customer_code: this.getLocalCustomerCode})
                setTimeout(() => {
                    let list = []
                    this.$store.getters.getCustomerMasterAutocompleteList.forEach(element => {
                    element.value = element.customer_name
                    
                    list.push(element)
                    })
                    cb(list)  
                }, 2000);
   
            }
            
        },
        loadSearchedItem($event) {

            if(this.search_type === 1) {
                this.$store.state.inventoryMaster.props.id = $event.id
                this.item_id = $event.id
                this.$store.dispatch('fetchSingleItemStock', {item_code: $event.id, unit_name: $event.unit_name, store_list: this.$store.getters.getAccessibleStoreList})
            } else if(this.search_type === 0) {

                this.$router.push('/salesappointments/?customer_id='+$event.id)
                this.$emit('closed')
                
            }

        },
        openQRScanner() {
            this.show_qr_window = true
        },
        onDecode($event) {
            this.search_text = $event
            this.searchSKUCode($event)
            this.show_qr_window = false
            this.changeFocus('inventory_item_id')
        },
        showStatement($event) {
            this.$store.state.inventoryMaster.statement.store_id = $event

            let currentDate = "";

            let date = new Date();

            let currentMonth = date.getUTCMonth()+1
            if(currentMonth<10) {
                currentMonth = "0"+currentMonth;
            }
            let currentDay = date.getUTCDate()
            if(currentDay<10) {
                currentDay = "0"+currentDay;
            }
            let currentYear = date.getUTCFullYear()

            currentDate = currentYear+'-'+currentMonth+'-'+currentDay
            
            this.$store.state.inventoryMaster.statement.date_range = ['2017-04-01', currentDate]
            this.show_statement = true
        }
    },
    mounted() {
        this.$store.state.inventoryMaster.stock_list = []

        setTimeout(() => {
            if(this.checkIfModuleAccessAvailable('/salesappointments', 'can_view')) {
                this.search_type = 0
            }
            
            if(this.checkIfModuleAccessAvailable('/inventoryproducts', 'can_view')) {
                this.search_type = 1
            } 
            
        }, 1000);
        this.$store.dispatch('fetchFabricPriceSlabList')
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/StockCheck/Index.vue